export const getLinkUrl = (href: string) => {
  const hostname = (typeof window !== 'undefined' && window.location.hostname) || undefined;

  if (href.includes('www') || href.includes('naf.no') || href.includes('http')) {
    return href;
  }
  return `${hostname}${href}`;
};
